<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>내담자 그룹관리</p>
               
            </div>

            <div class="area_body">
                <div class="area_section">
                    <img :src="state.data.file" style="width: 300px; height: auto" />
                </div>

                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>1. 그룹명</label>
                                </div>
                                <div class="area_col_body">
                                    <div>
                                        <input type="text" v-model="state.data.name" />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>2. 작성자</label>
                                </div>
                                <div class="area_col_body">
                                    <div>
                                        <p v-text="state.data.adName"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>3. 내담자 검색</label>
                                </div>
                                <div class="area_col_body" style="position: relative">
                                    <div class="flex ac">
                                        <div >
                                            <input type="text" v-model="state.searchNumber" v-on:keyup.enter="findClient()" class="w300" />
                                        </div>
    
                                        <div class="area_button">
                                            <button type="button" @click="findClient" class="type2"> 
                                                <span>검색</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="select-wrap" style="position: absolute; top: 40px" v-show="state.isSearch">
                                        <select
                                            v-model="state.selectedItem"
                                            @change="
                                                state.data.client.push({
                                                    clIdx: state.selectedItem.idx,
                                                    vstNo: state.selectedItem.number,
                                                });

                                                state.isSearch = false;
                                                state.selectedItem = {};
                                                state.list = [];
                                            "
                                        >
                                            <option
                                                :value="{ number: item.number, idx: item.idx }"
                                                v-text="item.number"
                                                v-for="(item, key) in state.list"
                                                :key="key"
                                            ></option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>3-1. 내담자</label>
                                </div>
                                <div class="area_col_row">
                                    <div class="area_col no-line-bottom" v-for="(item, key) in state.data.client" :key="key">
                                        <div class="flex ac">
                                            <img src="img/icon_client.png" />
                                            <p v-text="item.vstNo" class="vst_name"></p>
    
                                            <div class="area_button ">
                                                <button v-if="item.idx" type="button" @click="confirmRemoveMember(item.idx)" class="type3">삭제</button>
                                                <button v-else type="button" @click="state.data.client.splice(key, 1)" class="type3">삭제</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>4. 등록일자</label>
                                </div>
                                <div class="area_col_body">
                                    <div>
                                        <p v-text="CommonUtils.dateFormat(state.data.createDate, '.', true)"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="area_button area_form_btns">
                        <template v-if="state.mode">
                            <button type="button" @click="confirmAdd" class="active">
                                <span>등록</span>
                            </button>
                        </template>
                        <template v-else>
                            <button type="button" @click="confirmModify" class="active">
                                <span>수정</span>
                            </button>

                            <button type="button" @click="confirmRemove" class="delete">
                                <span>삭제</span>
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        :idx="state.removeIdx"
        @close="closeModal"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        reactive,
        apiService,
        onMounted,
        router,
        ModalDefault,
        types,
        getMessageByCode,
        CommonUtils,
        CommonOptions,
        watch,
        useRoute,
        Header,
        Left,
    } from "@/BaseComponent";

    export default {
        components: { ModalDefault, Left, Header },
        setup() {
            const route = useRoute();
            const state = reactive({
                idx: 0 as number,
                data: {
                    client: [] as Array<types.group.GroupMemberVOForApi>,
                } as types.group.GroupVOForApi | any,
                mode: true as boolean, // true: insert, false: update

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                removeIdx: 0 as number,

                gubun: 1 as 1 | 2 | 3 | 4, // 1: update, 2: delete, 3: insert, 4: remove member

                list: [] as Array<types.client.ClientVOForApi>,
                searchNumber: "" as string,

                isSearch: false as boolean,
                selectedItem: {} as any,
            });

            onMounted(() => {
                if (route.params.id) {
                    state.idx = Number(route.params.id);
                    detail();
                    state.mode = false;
                } else {
                    state.mode = true;
                }
            });

            watch(
                () => route.params.id,
                () => {
                    if (route.params.id) {
                        state.idx = Number(route.params.id);
                        detail();
                        state.mode = false;
                    } else {
                        state.mode = true;
                    }
                },
            );

            const detail = async () => {
                const res = await apiService.group.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                    state.list = [];
                }
            };

            const closeModal = () => {
                if (state.modalTab === 3) {
                    router.back();
                } else {
                    state.isShowModal = false;
                }
            };

            const confirmAdd = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 등록하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 3;
            };

            const confirmModify = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 변경하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 1;
            };

            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 2;
            };

            const confirmRemoveMember = (idx: number) => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 4;
                state.removeIdx = idx;
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 1:
                            modify();
                            break;
                        case 2:
                            remove();
                            break;
                        case 3:
                            add();
                            break;
                        case 4:
                            removeMember(param.idx);
                            break;
                    }
                } else if (param.action === "callback") {
                    switch (param.gubun) {
                        case 1:
                        case 4:
                            detail();

                            break;
                        case 2:
                            router.back();
                            break;
                        case 3:
                            router.push({ name: "group" });
                            break;
                    }
                    state.isShowModal = false;
                }
            };

            const add = async () => {
                const param: types.group.ReqGroup = {
                    name: state.data.name,
                    idxList: state.data.client.map((r: any) => r.clIdx).join(","),
                };
                const res = await apiService.group.add(param);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.gubun = 3;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const modify = async () => {
                const param: types.group.ReqGroup = {
                    name: state.data.name,
                    idxList: state.data.client.map((r: any) => r.clIdx).join(","),
                };

                const res = await apiService.group.modify(state.idx, param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "저장이 완료되었습니다.";
                    state.isShowModal = true;

                    detail();
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const remove = async () => {
                const res = await apiService.group.remove(state.idx);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "안내";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const removeMember = async (idx: number) => {
                const res = await apiService.group.removeForClient(state.idx, idx);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                    detail();
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const findClient = async () => {
                if (state.searchNumber.length < 2) {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "연번을 최소 2글자 이상 입력해주세요.";
                    state.isShowModal = true;
                    return;
                }
                const res = await apiService.client.search(state.searchNumber);
                if (res.returnCode === 0 && res.data && res.data.length > 0) {
                    state.list = res.data;

                    state.isSearch = true;
                } else if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = "검색된 결과가 없습니다.";
                    state.isShowModal = true;
                } else {
                    state.list = [];
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                CommonUtils,
                CommonOptions,

                closeModal,
                callbackModal,
                confirmAdd,
                confirmModify,
                confirmRemove,

                confirmRemoveMember,

                findClient,
            };
        },
    };
</script>
<style scoped>
    .container div.area_body div.area_section div.area_row div.area_col_row {
        gap: 5px;
        padding: 10px;
    }
    .container div.area_body div.area_section div.area_row div.area_col_row > div.area_col img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
    }
    
    .vst_name{
        font-size: 15px;
    }
    button.type3{
        padding: 2px 8px;
        font-size: 14px;
    }
</style>
